import { useCallback, useEffect, useState } from 'react'
import { Header } from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom'
import { Spinner } from '../../../components/Commons/Spinner/Spinner'
import GenericPromises from '../../../api/GenericPromises'
import { PrimaryButton } from '../../../theme/buttons'
import { Menuitem } from '../../../interfaces/Security/menu'
import DataTable from '../../../components/Tables/GridTableMaterialUI/DataTable'
import { GridColDef, GridRowsProp, GridTreeNodeWithRender, GridValueGetterParams } from '@mui/x-data-grid'
import { User } from '../../../interfaces/Security/users'
import { useTranslation } from 'react-i18next'
import { ItemFamily } from '../../../interfaces/Commons/Items/items'
import { usePermissions } from '../../../hooks/usePermissions'
import useSnackBar from '../../../components/Commons/SnackBar/useSnackBar'
import { useDates } from '../../../hooks/useDates'

export const TableItemFamilies = () => {
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const { TimeConverter } = useDates();
  const { GenericGetResource, GenericGetResourceGeneric } = GenericPromises();
  const { showSnackBar, SnackbarComponent } = useSnackBar();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [unauthorized, setUnauthorized] = useState(true);
  const [itemFamiliesData, setItemFamiliesData] = useState<GridRowsProp>([]);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const [messageSnack, setMessageSnack] = useState("");
  const [myPreferences, setMyPreferences] = useState({});
  const { GetResourceByUrl } = usePermissions();
  const [columns, setColumns] = useState<GridColDef<ItemFamily>[]>([
    { field: 'item_family_code', headerName: t("item-families.fields.item_family_code"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'item_family_name', headerName: t("item-families.fields.item_family_name"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'item_family_description', headerName: t("item-families.fields.item_family_description"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
    { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
  ]);



  const methodUsed = useCallback(() => {
    switch (location.state.method) {
      case "add":
        {
          showSnackBar(t("generic.snackbar.add"), "success");
          break;
        }
      case "delete":
        {
          showSnackBar(t("generic.snackbar.delete"), "success");
          break;
        }
    }

  }, [location.state, t]);

  const loadPreferences = async () => {
    let myPreferences = await localStorage.getItem("grid-item-families");
    if (myPreferences != null) {
      setMyPreferences(JSON.parse(myPreferences));
    }
  }

  const loadColumnsOrder = async () => {
    let myOrderColumns = await localStorage.getItem("grid-item-families-columns");
    if (myOrderColumns != null) {
      let myJson = JSON.parse(myOrderColumns);
      for (let index = 0; index < myJson.length; index++) {
        const element = myJson[index];
        if (element['type'] === 'date') {
          element.headerName = t(`generic.${element.field}`);
          element.valueGetter = function (params: GridValueGetterParams<User, any, GridTreeNodeWithRender>) {
            return TimeConverter(params.value);
          };
        }
        if (element.field) { }
        else {
          element.headerName = t(`item-families.fields.${element.field}`);
        }
      }
      setColumns(myJson);
    }
  }



  useEffect(() => {
    GenericGetResourceGeneric("/companies", "/gcompanies").then((response) => {
      document.title = `${response.data.data[0].comercial_name} - ${t("item-families.title")}`;
    })

    if (location.state !== null && location.state.method) methodUsed();
    GenericGetResource(`/itemfamilies`)
      .then(
        (response) => {
          setItemFamiliesData(response.data.data);

          GetResourceByUrl(`/itemfamilies`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              loadColumnsOrder();
              loadPreferences();
              setDataLoaded(true);
            })
            .catch((error) => {
              setMessageSnack(error.message);
              showSnackBar(error.message, 'error');
              setUnauthorized(false);
            });
        }
      ).catch((error) => {
        setMessageSnack(error.message);
        showSnackBar(error.message, 'error');
        setUnauthorized(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      {!unauthorized && <div className='screen-container d-flex flex-column justify-content-center align-items-center'> <img alt='ERROR' style={{ height: "20rem", width: "20rem" }} src={require("../../../assets/img/error.webp")} /> <h2>{messageSnack}</h2> </div>}
      {unauthorized && !dataLoaded && <Spinner />}
      {dataLoaded && resourceScreen?.read && <div className='screen-container'>
        <Header
          title={t("item-families.title")}
          child={
            <div className='d-flex flex-row-reverse my-1'>
              {resourceScreen?.create === true &&
                <PrimaryButton variant='outlined' className="my-1" onClick={() => { navigate("add", { state: { ...location.state } }) }}>{t("generic.buttons.add")}</PrimaryButton>
              }
            </div>
          }
        />

        <div className="d-flex justify-content-center">
          <DataTable columns={columns} setColumns={setColumns} data={itemFamiliesData} entityId={"item_family_id"} entity={`ItemFamilies`} preferences={myPreferences} namePreferences={"grid-item-families"} nameOrderColumns={"grid-item-families-columns"} />
        </div>
        <SnackbarComponent />
      </div>
      }
    </>
  )
}
